






































import { CountryCodeEnum } from "@/lib/enum/country-code.enum";
import { ReportRoleEnum } from "@/lib/enum/ReportRole.enum";
import { emailRule, phoneRule } from "@/lib/rules/contactRule";
import { handleError } from "@/lib/utility/handleError";
import { ReportEntity } from "@/models/reportEntity";
import {
  MrfiktivCreateActivityLogDtoGen,
  MrfiktivCreateLeasingDetailsDtoGen,
  MrfiktivCreatePoliceDetailsDtoGen,
  MrfiktivCreateReportAsPartnerDtoGen,
  MrfiktivCreateReportWittnesDtoGen,
  MrfiktivLeasingDetailsGen,
  MrfiktivReferenceGen,
  MrfiktivUpdateReportDtoGen
} from "@/services/mrfiktiv/v1/data-contracts";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { DamageTypeEnum } from "@/store/enum/damageType.enum";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ReportType } from "@/store/enum/reportType";
import { ActivityTypeEnum, ActivityLogModule } from "@/store/modules/activity-log.store";
import { PartnerModule } from "@/store/modules/partner";
import { ReportPaginationModule } from "@/store/modules/report-pagination.store";
import { Component, Prop, Vue } from "vue-property-decorator";
import LatestEntriesCardEmpty from "../cards/LatestEntriesCardEmpty.vue";
import CreateReportForm from "../fleet/CreateReportForm.vue";
import { getCreateReportDto } from "@/lib/dto/create-report-as-partner-dto";
import Card from "../utility/Card.vue";
import ConfirmActionDialog from "../utility/ConfirmActionDialog.vue";
import DateTimePicker from "../utility/DateTimePicker.vue";
import Tooltip from "../utility/tooltip.vue";
import PartnerReportCardAccidentDetails from "./PartnerReportCardAccidentDetails.vue";
import PartnerReportCardAddress from "./PartnerReportCardAddress.vue";
import PartnerReportCardContact from "./PartnerReportCardContact.vue";
import PartnerReportCardDamage from "./PartnerReportCardDamage.vue";
import PartnerReportCardDatePreference from "./PartnerReportCardDatePreference.vue";
import PartnerReportCardGeneral from "./PartnerReportCardGeneral.vue";

export enum ReportUpdateTabEnum {
  report = "report",
  accident = "accident",
  witness = "witness",
  police = "police",
  body = "body",
  message = "message",
  contact = "contact",
  leasing = "leasing"
}

@Component({
  components: {
    ConfirmActionDialog,
    DateTimePicker,
    Card,
    Tooltip,
    LatestEntriesCardEmpty,
    PartnerReportCardGeneral,
    PartnerReportCardAddress,
    PartnerReportCardContact,
    PartnerReportCardDatePreference,
    PartnerReportCardDamage,
    PartnerReportCardAccidentDetails,
    CreateReportForm
  }
})
export default class PartnerReportUpdateReportDialog extends Vue {
  @Prop()
  config!: ReportUpdateTabEnum[];

  @Prop({ default: "report" })
  activityTarget?: string;

  @Prop({ default: false })
  fullscreen!: boolean;

  tab = 0;
  isDialogActive = false;
  updateLoading = false;
  updateReportDto: MrfiktivUpdateReportDtoGen = {};
  isValid = true;

  get md() {
    if (this.fullscreen) {
      return 3;
    }
    return 6;
  }

  get TabEnum() {
    return ReportUpdateTabEnum;
  }

  get activeTabsCount() {
    let count = 0;

    count += Number(this.isReport);
    count += Number(this.isAccidentDetails);
    count += Number(this.isPoliceDetails);
    count += Number(this.isLeasingDetails);
    count += Number(this.isBody);

    return count;
  }

  get partnerScreens() {
    return PartnerModule.partner.settings?.reportSettings?.screenOrder || [];
  }

  get isReport() {
    if (this.$route.query.forceTabsForTesting) {
      return true;
    }

    if (!this.config.includes(ReportUpdateTabEnum.report)) {
      return false;
    }

    return true;
  }
  get isAccidentDetails() {
    if (this.$route.query.forceTabsForTesting) {
      return true;
    }

    if (!this.config.includes(ReportUpdateTabEnum.accident)) {
      return false;
    }

    if (this.report.accidentDetails) {
      return true;
    }

    if (this.partnerScreens.includes(ReportScreenEnum.accidentdetails)) {
      return true;
    }

    return false;
  }
  get isWitness() {
    if (this.$route.query.forceTabsForTesting) {
      return true;
    }

    if (!this.config.includes(ReportUpdateTabEnum.witness)) {
      return false;
    }

    if (this.report.witness?.length) {
      return true;
    }

    if (this.partnerScreens.includes(ReportScreenEnum.witness)) {
      return true;
    }

    return false;
  }
  get isPoliceDetails() {
    if (!this.config.includes(ReportUpdateTabEnum.police)) {
      return false;
    }

    if (this.report.policeDetails) {
      return true;
    }

    if (this.partnerScreens.includes(ReportScreenEnum.police)) {
      return true;
    }

    return false;
  }

  get isLeasingDetails() {
    if (this.$route.query.forceTabsForTesting) {
      return true;
    }

    if (!this.config.includes(ReportUpdateTabEnum.leasing)) {
      return false;
    }

    if (this.report.leasing) {
      return true;
    }

    if (this.partnerScreens.includes(ReportScreenEnum.leasing)) {
      return true;
    }

    return false;
  }

  get isBody() {
    if (this.$route.query.forceTabsForTesting) {
      return true;
    }

    if (!this.config.includes(ReportUpdateTabEnum.body)) {
      return false;
    }

    if (this.report.body) {
      return true;
    }

    return true;
  }
  get isMessage() {
    if (!this.config.includes(ReportUpdateTabEnum.message)) {
      return false;
    }

    return true;
  }
  get isContact() {
    if (this.$route.query.forceTabsForTesting) {
      return true;
    }

    if (!this.config.includes(ReportUpdateTabEnum.contact)) {
      return false;
    }

    return true;
  }

  get isExternalId() {
    if (this.$route.query.forceTabsForTesting) {
      return true;
    }

    if (this.partnerScreens.includes(ReportScreenEnum.externalidhueffermann)) {
      return true;
    }

    if (this.report.externalId) {
      return true;
    }

    return false;
  }

  get report() {
    return PartnerModule.report;
  }

  get reportTypeItems() {
    return Object.values(ReportType);
  }
  get damageItems() {
    return Object.values(DamageTypeEnum);
  }
  get countryCodeItems() {
    return Object.values(CountryCodeEnum);
  }
  get roleItems() {
    return Object.values(ReportRoleEnum);
  }

  get emailRules() {
    return [emailRule()];
  }
  get phoneRules() {
    return [phoneRule()];
  }

  get accidentDetailsDate() {
    if (!this.updateReportDto.accidentDetails) {
      return new Date();
    }
    return new Date(this.updateReportDto.accidentDetails.date);
  }
  set accidentDetailsDate(date: Date) {
    if (!this.updateReportDto.accidentDetails) {
      return;
    }
    this.updateReportDto.accidentDetails.date = date.toISOString();
  }

  addWitness() {
    const emptyWitness: MrfiktivCreateReportWittnesDtoGen = {
      firstName: "",
      lastName: "",
      contact: {
        email: "",
        phone: ""
      },
      imageIds: []
    };
    if (!this.updateReportDto.witness) {
      this.updateReportDto = { ...this.updateReportDto, witness: [emptyWitness] };
    } else {
      this.updateReportDto.witness.push(emptyWitness);
    }
  }
  removeWitness(index: number) {
    this.updateReportDto.witness?.splice(index, 1);
  }
  addPoliceDetails() {
    const policeDetails = {
      isRecorded: false,
      department: "",
      fileReference: ""
    };

    this.updateReportDto = { ...this.updateReportDto, policeDetails };
  }

  addLeasingDetails() {
    const leasing: MrfiktivLeasingDetailsGen = {
      isLeasing: false,
      company: "",
      claimNumber: ""
    };

    this.updateReportDto = { ...this.updateReportDto, leasing };
  }

  addCustomerContact() {
    this.updateReportDto = { ...this.updateReportDto, customerContact: { email: "", phone: "" } };
  }
  removeCustomerContact() {
    this.updateReportDto = { ...this.updateReportDto, customerContact: undefined };
  }
  addCustomerAddress() {
    this.updateReportDto = {
      ...this.updateReportDto,
      customerAddress: { city: "", state: "", street: "", zip: "", countryCode: "" }
    };
  }
  removeCustomerAddress() {
    this.updateReportDto = { ...this.updateReportDto, customerAddress: undefined };
  }

  mapReportToUpdateDto(report: ReportEntity): MrfiktivUpdateReportDtoGen {
    let mapReportToUpdateDto: MrfiktivUpdateReportDtoGen = {};

    mapReportToUpdateDto.vehicleId = report.vehicleId;

    if (report.message) {
      mapReportToUpdateDto = {
        ...mapReportToUpdateDto,
        message: report.message
      };
    }
    mapReportToUpdateDto = {
      ...mapReportToUpdateDto,
      customerName: report.customerName,
      firstName: report.firstName,
      lastName: report.lastName,

      companyName: report.companyName,
      externalId: report.externalId,
      numberplate: report.numberplate ?? "",
      message: report.message || "",
      damage: (report.damage as any) || [],
      reportType: report.reportType || "",
      datePreference: report.datePreference,
      body: report.body
    };

    if (this.isContact && report.customerContact) {
      mapReportToUpdateDto.customerContact = {
        email: report.customerContact.email || "",
        phone: report.customerContact.phone || ""
      };
    }
    if (this.isContact && report.customerAddress) {
      mapReportToUpdateDto.customerAddress = {
        city: report.customerAddress.city || "",
        state: report.customerAddress.state || "",
        street: report.customerAddress.street || "",
        zip: report.customerAddress.zip || "",
        countryCode: report.customerAddress.countryCode || CountryCodeEnum.germany
      };
    }

    if (this.isAccidentDetails && report.accidentDetails) {
      const accidentDetails = {
        address: {
          city: report.accidentDetails.address.city || "",
          geo: { lat: report.accidentDetails.address.geo.lat || 0, lng: report.accidentDetails.address.geo.lng || 0 },
          state: report.accidentDetails.address.state || "",
          street: report.accidentDetails.address.street || "",
          zip: report.accidentDetails.address.zip || "",
          countryCode: report.accidentDetails.address.countryCode || CountryCodeEnum.germany
        },
        comment: report.accidentDetails.comment || "",
        date: report.accidentDetails.date,
        role: report.accidentDetails.role || ReportRoleEnum.UNCLEAR
      };

      mapReportToUpdateDto = { ...mapReportToUpdateDto, accidentDetails };
    }
    if (this.isPoliceDetails && report.policeDetails) {
      const policeDetails: MrfiktivCreatePoliceDetailsDtoGen = {
        isRecorded: report.policeDetails.isRecorded,
        department: report.policeDetails.department || "",
        fileReference: report.policeDetails.fileReference || ""
      };

      mapReportToUpdateDto = { ...mapReportToUpdateDto, policeDetails };
    }

    if (this.isWitness) {
      const witness: MrfiktivCreateReportWittnesDtoGen[] = report.witness || [];

      mapReportToUpdateDto = { ...mapReportToUpdateDto, witness };
    }

    if (this.isLeasingDetails && report.leasing) {
      const leasing: MrfiktivCreateLeasingDetailsDtoGen = {
        isLeasing: report.leasing?.isLeasing || false,
        company: report.leasing?.company || "",
        claimNumber: report.leasing?.claimNumber || ""
      };

      mapReportToUpdateDto = { ...mapReportToUpdateDto, leasing };
    }

    return mapReportToUpdateDto;
  }

  startDialog() {
    this.updateReportDto = this.mapReportToUpdateDto(this.report);

    this.isDialogActive = true;
  }

  async update() {
    try {
      const partnerId = this.report.partnerId;
      const reportId = this.report._id;
      this.updateLoading = true;
      const createDto: MrfiktivCreateReportAsPartnerDtoGen = getCreateReportDto({
        ...this.updateReportDto,
        damage: this.updateReportDto.damage as DamageTypeEnum[],
        reportType: this.updateReportDto.reportType as ReportType
      });

      // Fix for issue where create DTO expects wittness, update dto expects witness.
      const witness = createDto.wittness;
      createDto.wittness = undefined;
      const updateDto = {
        ...createDto,
        witness
      };

      const update = await PartnerModule.updateReport({
        partnerId,
        reportId,
        updateDto
      });
      ReportPaginationModule.replaceInList(update);
      this.isDialogActive = false;

      const source: MrfiktivReferenceGen = {
        refType: BackendResourceEnum.REPORT,
        refId: reportId
      };
      const data: MrfiktivCreateActivityLogDtoGen = {
        source,
        actionType: ActionEnum.UPDATE,
        comment: this.activityTarget,
        isDeletable: true,
        activity: ActivityTypeEnum.UPDATE_REPORT
      };

      const activity = await ActivityLogModule.create({
        partnerId,
        data
      }).catch(handleError);

      if (activity) {
        ActivityLogModule.addToList(activity);
      }
    } catch (e) {
      handleError(e);
    } finally {
      this.updateLoading = false;
    }
  }
}
